<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-4xl w-full max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Call Transcript</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div class="bg-gray-50 p-4 rounded">
          <div class="flex justify-between items-center mb-2">
            <span class="font-medium">{{ call.profile?.name || 'Unknown' }}</span>
            <span class="text-sm text-gray-500">{{ formatDate(call.created_at) }}</span>
          </div>
          <span class="text-sm text-gray-600">Duration: {{ formatDuration(call.duration) }}</span>
        </div>
        
        <div class="bg-white border rounded p-4 max-h-96 overflow-y-auto">
          <div v-if="call.transcript" class="whitespace-pre-wrap text-sm">
            {{ call.transcript }}
          </div>
          <div v-else class="text-gray-500 text-center py-8">
            No transcript available for this call
          </div>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button @click="downloadTranscript" class="btn btn-secondary">
            Download
          </button>
          <button @click="$emit('close')" class="btn btn-primary">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import dayjs from 'dayjs'

const props = defineProps({
  call: {
    type: Object,
    required: true
  }
})

defineEmits(['close'])

function formatDate(date) {
  return dayjs(date).format('MMM DD, YYYY h:mm A')
}

function formatDuration(seconds) {
  if (!seconds) return 'N/A'
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}

function downloadTranscript() {
  const content = props.call.transcript || 'No transcript available'
  const blob = new Blob([content], { type: 'text/plain' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `transcript-${props.call.id}.txt`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(url)
}
</script>